import { CommunityWins } from '@platform/client';
import { Input, Modal } from '@platform/components';
import { useQueryClient } from '@tanstack/react-query';
import { CommunityWin } from '@platform/client/schemas';
import { useState } from 'react';

interface UpdateCommunityWinModalProps {
  isOpen: boolean;
  onClose: () => void;
  communityWin: CommunityWin;
  page?: number;
  limit?: number;
}

export const UpdateCommunityWinModal = (props: UpdateCommunityWinModalProps) => {
  const { communityWin, isOpen, onClose, page, limit } = props;

  const [title, setTitle] = useState(communityWin.title);
  const [description, setDescription] = useState(communityWin.description);
  const [link, setLink] = useState(communityWin.link || '');

  const queryClient = useQueryClient();

  const submitCommunityWin = CommunityWins.useUpdateCommunityWin({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: CommunityWins.getGetCommunityWinsQueryKey({
            limit: limit || 0,
            page: page || 0,
          }),
        });
      },
    },
  });

  const updateCommunityWin = () => {
    submitCommunityWin.mutate({
      data: {
        id: communityWin.id,
        title,
        description,
        link,
      },
    });

    closeModal();
  };

  const closeModal = () => {
    onClose();
    setTitle('');
    setDescription('');
  };

  return (
    <Modal
      variant='dialog'
      title='Update Community Win'
      isOpen={isOpen}
      headerDivision='divider'
      ignoreExtraPadding={true}
      onClose={closeModal}
      primaryCTA={{
        text: 'Update Community Win',
        callback: updateCommunityWin,
      }}
      secondaryCTA={{
        text: 'Cancel',
        callback: closeModal,
      }}
    >
      <div className='md:w-[460px]'>
        <div className='flex flex-col gap-4 w-full'>
          <Input
            label='Title'
            type='inline'
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <Input
            label='Description'
            type='multiline'
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <Input
            label='Link'
            type='inline'
            value={link}
            onChange={(e) => setLink(e.target.value)}
          />
        </div>
      </div>
    </Modal>
  );
};
